import QuestionInstructionsModal from './QuestionInstructionsModal';

export default QuestionInstructionsModal;
